<template>
    <v-container fluid tag="section" class="px-3">

        <external-server-modal
                :object_id.sync="object_id"
                @closeModal="closeModal"
        />

        <v-row class="wrapper flex-nowrap">

            <v-col>
                <div class="tables mt-0">
                    <div>
                        <v-card class="ma-0 my-2 w-100">
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                    <tr>
                                        <th
                                                v-for="item in tableHeaders"
                                                :key="item"
                                                class="table-cell"
                                        >{{ item }}
                                        </th>
                                    </tr>
                                    </thead>

                                    <tbody>
                                    <tr v-for="item in tableData" :key="item.id">

                                        <!-- ID -->
                                        <td class="table-cell">{{ item.id }}</td>

                                        <!-- Статус -->
                                        <td class="table-cell" style="color: #1F813E;">
                                            <div v-if="item.fullcontact"
                                                 style="color: #5FA057;">
                                                Online
                                            </div>
                                            <div v-else
                                                 style="color: red;">
                                                Offline
                                            </div>
                                        </td>

                                        <!-- Описание -->
                                        <td class="table-cell text-left">
                                            <div class="d-flex align-center text-capitalize">
                                                <div>
                                                    <span
                                                            class="display-1 font-weight-bold"
                                                            @click="edit(item.id)"
                                                    >{{ item.fullname }}
                                                    </span>
                                                </div>
                                            </div>
                                        </td>

                                        <!-- Номер -->
                                        <td class="table-cell">{{ item.name }}</td>

                                        <!-- domain -->
                                        <td class="table-cell">{{ item.host }}</td>

                                        <td class="table-cell">
                                            <div class="text-overflow caption">
                                                <v-btn
                                                        @click="edit(item.id)"
                                                        icon
                                                        small
                                                        class="action-button green--text"
                                                >
                                                    <v-icon small>mdi-pencil</v-icon>
                                                </v-btn>
                                            </div>
                                        </td>

                                    </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </div>
                </div>
            </v-col>
            <!-- Правая колонка END -->
        </v-row>
    </v-container>
</template>

<script>
    import ExternalServerModal from './components/ExternalServerModal'

    import axios from 'axios'

    export default {
        name: 'ExternalServer',

        components: { ExternalServerModal },

        data: function () {
            return {
                open: ['public'],
                menu: false,

                tableHeaders: [
                    'ID',
                    'Статус',
                    'Описание',
                    'Номер',
                    'host',
                    'Редакция',
                ],

                tableData: [],

                // id - выбраного объекта:
                object_id: -1,
            }
        },

        methods: {
            /**
             * Получить список sippeers.
             */
            getListSippeers () {
                axios({
                    method: 'get',
                    url: process.env.VUE_APP_API_URL_PHONE + 'get-list-external-server',
                }).then((response) => {

                    console.log(response.data)

                    this.tableData = response.data

                }).catch(error => alert(error))
            },

            edit (id) {
                console.log('edit(): ' + id)

                this.object_id = id
            },

            closeModal(){
                console.log('closeModal()');

                this.object_id = -1;

                this.getListSippeers();
            }
        },

        created () {

            console.log('created() -- SimCards')

            this.getListSippeers()
        },
    }
</script>

<style scoped>
    /* сетка */

    .wrapper {
        height: 100%;
    }

    /* левая колонка */

    .left-column {
        height: 100%;
        flex-grow: 0;
        flex-shrink: 0;
        min-width: 290px;
        max-width: 290px;
    }

    .tree {
        height: calc(100% - 30px);
        /* height: auto; */
    }

    .card-tree {
        position: relative;
        height: 100%;
    }

    .card-tree-title {
        position: absolute;
        top: -17px;
        width: calc(100% - 32px);
        min-height: 48px;
        font-size: 14px !important;
        margin: 0 !important; /* убираем лишние отступы у плашки "Оператор" в дереве */
    }

    .card-tree-content {
        height: 100%;
        width: 100%;
        overflow-y: auto; /* полоса прокрутки для дерева, в случае увеличения высоты */
        overflow-x: hidden;
    }

    /* правая колонка */

    .right-column {
        height: 100%;
        /* flex-grow: 1; */
        /* flex-shrink: 0; */
        /* min-width: 700px; */
        overflow-x: auto !important;
    }

    .tables {
        margin-top: 30px;
        border-radius: 4px;
        height: calc(100% - 30px);
    }

    .v-data-table {
        min-width: 650px;
    }

    /* таблицы */

    th:nth-child(3) {
        text-align: left !important;
    }

    .table-title {
        text-transform: uppercase;
        font-size: 14px;
        line-height: 1.3;
        color: #0051ff;
    }

    .table-title span {
        font-size: 12px;
        text-transform: capitalize;
        display: inline-block;
        font-weight: normal;
        color: initial;
        vertical-align: top; /* выравниваем строку по высоте */
        padding-top: 0px;
    }

    .table-cell {
        font-size: 12px;
        text-align: center !important;
    }

    .text-left {
        text-align: left !important;
    }

    .operator-title {
        color: #94bcff;
    }

    /* настройки операторов */

    .operator-settings-wrapper {
        position: fixed;
        top: 125px;
        right: 0;
        z-index: 998;
    }

    .operator-settings-button {
        background-color: rgba(0, 0, 0, 0.5);
        border-radius: 8px 0 0 8px;
        min-width: 65px;
        height: 52px;
    }

    /* медиазапросы */

    @media (max-width: 800px) {
        .wrapper {
            display: block;
            margin: 0; /* убираем отрицательные margin -12px */
        }

        .left-column {
            margin-left: -12px;
        }
    }

    /* лого оператора в настройках */

    .operator-img {
        display: flex;
        align-items: center;
    }

    .operator-img::before {
        content: '';
        width: 36px;
        height: 36px;
        border-radius: 4px;
        padding: 0;
        margin-right: 12px;
        background-color: #0051ff;
        background-size: contain;
        background-position: center;
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.14),
        0 7px 10px -5px rgba(76, 175, 80, 0.4) !important;
    }

    .kyivstar.operator-img::before {
        background-image: url('../../../assets/img/sim_cards/kyivstar-logo.png');
    }

    .lifecell.operator-img::before {
        background-image: url('../../../assets/img/sim_cards/lifecell-logo.png');
    }

    .vodafone.operator-img::before {
        background-image: url('../../../assets/img/sim_cards/vodafone-logo.png');
    }
</style>
